import { useEffect, useState } from "react";
import { URL_API } from "../../utils/helper/helpers";
import axios from "axios";
import { toast } from "react-toastify";

interface ProduitInterface {
    [key: string]: any;
}

const useProduitListe = (refresh: boolean): ProduitInterface[] => {
    const [produit, setProduit] = useState<ProduitInterface[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchProduit = async () => {
            axios.get(`${URL_API}/produit/all`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.data.success) {
                    setProduit(response.data.produits);
                }

            }).catch(error => {
                if (!error.response.data.success) {
                    toast.info(error.response.data.message);
                }
            })
        };

        fetchProduit();
    }, [refresh]);
    return produit;
};
export default useProduitListe;

export const deleteProduit = async ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/produit/delete/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.status == 200) {
            toast.warning("Élément Supprimer avec succès")
        }
        onSuccess();

    }).catch(error => {
        if (error.response.status === 404 || error.response.status === 500) {
            toast.info(error.response.data.message)
        }
    })

}

export const changeStatus = ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/produit/changeStatus/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {
        if (response.data.success) {
            toast.success("Status Changé avec success")
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 405) {
            toast.info(error.response.data.message)
        }
    })

}